import React from "react";
import { Route, Routes } from "react-router-dom";
import ROUTES_NAVIGATION from "./routes";
import NotificationList from "../components/DealerManagement/Admin/NotificationManagement/NotificationList";
import SetNotification from "../components/DealerManagement/Admin/NotificationManagement/SetNotification";
import UpdateNotification from "../components/DealerManagement/Admin/NotificationManagement/UpdateNotification";


const NotificationRoutes = () => {
  return (
    <>
    <Route
        path={ROUTES_NAVIGATION.NOTIFICATIONLIST}
        element={<NotificationList />}
      />
       <Route
        path={ROUTES_NAVIGATION.SETNOTIFICATION}
        element={<SetNotification />}
      />
        <Route
        path={ROUTES_NAVIGATION.UPDATENOTIFICATION}
        element={<UpdateNotification />}
      />
    </>
  );
};

export default NotificationRoutes;
